import { useState, type FormEvent } from 'react';
import { contactContent } from '@/mocks/home';

export default function ContactSection() {
  const [formStatus, setFormStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [formMessage, setFormMessage] = useState('');

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    const honeypot = (formData.get('website_alt') as string || '').trim();
    if (honeypot) {
      setFormStatus('success');
      setFormMessage('消息已发送，我们会尽快回复！');
      form.reset();
      return;
    }
    formData.delete('website_alt');

    try {
      const res = await fetch('https://readdy.ai/api/form/d9ku49ec26n1c7c5qn30', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const responseText = await res.text();
      let parsed: Record<string, unknown> = {};
      try { parsed = JSON.parse(responseText); } catch { /* ignore */ }

      if (res.ok && (parsed as { code?: string })?.code === 'OK') {
        setFormStatus('success');
        setFormMessage('消息已发送，我们会尽快回复！');
        form.reset();
      } else {
        const serverMsg = (parsed as { meta?: { message?: string } })?.meta?.message || '发送失败，请稍后重试';
        setFormStatus('error');
        setFormMessage(serverMsg);
      }
    } catch {
      setFormStatus('error');
      setFormMessage('网络错误，请稍后重试');
    }
  };

  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="max-w-[600px] mx-auto text-center">
            <h2 className="font-heading text-xl md:text-3xl font-bold text-foreground-950 mb-3">
              联系我们
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-8">
              {contactContent.description}
            </p>

            <div className="bg-background-100 rounded-xl p-6 md:p-8 border border-background-200/70">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mb-6 text-left">
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 shrink-0">
                    <i className="ri-mail-line text-primary-600 text-lg"></i>
                  </div>
                  <div>
                    <div className="text-xs text-foreground-500 mb-0.5">电子邮箱</div>
                    <div className="text-sm font-medium text-foreground-900">{contactContent.email}</div>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 shrink-0">
                    <i className="ri-time-line text-accent-600 text-lg"></i>
                  </div>
                  <div>
                    <div className="text-xs text-foreground-500 mb-0.5">服务时间</div>
                    <div className="text-sm font-medium text-foreground-900">{contactContent.hours}</div>
                  </div>
                </div>
              </div>

              <form
                data-readdy-form="true"
                className="text-left"
                onSubmit={handleSubmit}
              >
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-3">
                  <input
                    type="text"
                    name="name"
                    placeholder="您的昵称"
                    className="px-4 py-2.5 bg-background-50 border border-background-300 rounded-lg text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors"
                  />
                  <input
                    type="email"
                    name="email"
                    placeholder="电子邮箱"
                    className="px-4 py-2.5 bg-background-50 border border-background-300 rounded-lg text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors"
                  />
                </div>
                <textarea
                  name="message"
                  placeholder="请描述您的反馈或合作意向..."
                  rows={4}
                  maxLength={500}
                  className="w-full px-4 py-2.5 bg-background-50 border border-background-300 rounded-lg text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors resize-none mb-3"
                ></textarea>
                <input
                  type="text"
                  name="website_alt"
                  className="honeypot-field"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  readOnly
                />
                <button
                  type="submit"
                  className="w-full sm:w-auto px-6 py-2.5 bg-primary-500 text-background-50 text-sm font-semibold rounded-lg hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                >
                  发送消息
                </button>
                {formStatus !== 'idle' && (
                  <div className={`mt-3 text-sm font-medium ${
                    formStatus === 'success' ? 'text-primary-600' : 'text-red-600'
                  }`}>
                    {formMessage}
                  </div>
                )}
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}